import React, { useState, useEffect, useRef } from "react";
import { useParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../redux/hooks";
import Legends from "../Legends";
import { Loader, SegmentedControl } from "@mantine/core";
import TvConnetion from "./TvConnection";
import moment from "moment";
import "../../pages/location/location.css";

import {
  useGetLocationsQuery,
  useGetSensorsQuery,
} from "../../redux/slices/api.slice";
import { useGetFloorQuery, useGetDesksQuery } from "../../hooks/hooks";
import { setBreadcrumb } from "../../redux/slices/breadCrumb.slice";

import * as d3 from "d3";
import { floorType } from "../../interfaces/groups";
import ChairIcon from "../../svg/chairIcon";
import WifiIcon from "../../svg/wifiIcon";
import CupIcon from "../../svg/coffeCupIcon";
import MettingsIcon from "../../svg/meetingIocn";
import PrinterIcon from "../../svg/printerIcon";
import WheelChairIcon from "../../svg/weelchairIcon";
import PetIcon from "../../svg/petIcon";
import CouchIcon from "../../svg/couchIcon";
import MuteIcon from "../../svg/muteIcon";
import { LogoHcc } from "../../svg/Logo";

export interface locationProps {
  presentation?: boolean;
}

export function TvLengends() {
  let { id, GrpId } = useParams();
  const dispatch = useAppDispatch();

  const { desks, floors } = useAppSelector((state) => state.groups);

  const { isLoading: loadingDesk } = useGetDesksQuery(id, { skip: !id });

  const [svg, setSvg] = useState<string>("");

  const { isLoading } = useGetFloorQuery(id, { skip: !id });
  const [floor, setFloor] = useState<floorType | null>(null);

  const amenitiesData = [
    { label: "Wi-Fi Available", icon: WifiIcon },
    { label: "Coffee Space", icon: CupIcon },
    { label: "Meetings Room", icon: MettingsIcon },
    { label: "Printers", icon: PrinterIcon },
    { label: "Wheelchair Accessible", icon: WheelChairIcon },
    { label: "Pet-friendly", icon: PetIcon },
    { label: "Lounge Area", icon: CouchIcon },
    { label: "Quiet Zones", icon: MuteIcon },
  ];
  useEffect(() => {
    if (id) {
      const index = floors.findIndex((floor) => floor?.id === id);
      setFloor(floors[index]);
    }
  }, [floors, id]);

  const [editedName, setEditedName] = useState("");
  const isBasicUser = true;

  const [isLoaded, setIsLoaded] = useState<boolean>(false);
  const [isErrored, setIsErrored] = useState<boolean>(false);

  const [availableDesks, setAvailableDesks] = useState<string>("");

  useEffect(() => {
    setSvg("");
    if (floor?.svgURL) {
      fetch(floor?.svgURL as "RequestInfo | URL")
        .then((res) => res.text())
        .then(setSvg)
        .catch(setIsErrored)
        .then(() => setIsLoaded(true));
    }
  }, [floor?.svgURL]);

  useEffect(() => {
    floor?.name && setEditedName(floor.name);
  }, [floor?.name]);

  if (isLoading) {
    return (
      <div className="flex w-full h-[100vh] justify-center items-center">
        <Loader />
      </div>
    );
  }

  return (
    <>
      <TvConnetion />
      <div className="block cursor-pointer  absolute top-10 left-4">
        <LogoHcc className="w-[120px] h-[74px]" />
      </div>
      <div
        className={`flex justify-center items-center my-4 flex-col w-full h-full mx-auto   px-6   `}
      >
        <div className="mt-8 w-fit  mx-auto ">
          <div className="w-full">
            {isBasicUser ? <Legends role="basic" /> : <Legends role="admin" />}
          </div>
        </div>
        {isLoaded ? (
          <SvgContent
            svg={svg}
            floor={floor}
            desks={desks}
            id={id}
            setAvailableDesks={setAvailableDesks}
            isBasicUser={isBasicUser}
          />
        ) : isErrored ? (
          <div className="flex w-full h-[600px] mb-5 justify-center items-center border border-solid border-[#D5DAE1] rounded-[20px]">
            <p className="text-grayText3">Error fetching floor schema</p>
          </div>
        ) : floor?.svgURL ? (
          <div className="flex w-full h-[600px] mb-5 justify-center items-center border border-solid border-[#D5DAE1] rounded-[20px]">
            <p className="text-grayText3">
              Loading floor schema<span className="loading">...</span>
            </p>
          </div>
        ) : (
          <div className="flex w-full h-[600px] mb-5 justify-center items-center border border-solid border-[#D5DAE1] rounded-[20px]">
            <p className="text-grayText3">No Schema </p>
          </div>
        )}
      </div>
    </>
  );
}

export default TvLengends;

const SvgContent = ({
  svg,
  floor,
  desks,
  id,
  setAvailableDesks,
  isBasicUser,
}) => {
  const svgContainer = useRef();
  React.useEffect(() => {
    function handleColors() {
      const filteredDesks = desks?.[id];

      const rects = d3.selectAll("rect");

      rects.each(function (data, index) {
        const rect = d3.select(this);
        const rectID = rect.attr("id");

        if (rectID && rectID.includes("desk")) {
          const id = rectID.split("-")[1];

          rect
            .attr("class", " ")
            .attr("data-tooltip-id", "tooltip")
            .attr("data-tooltip-content", id)
            .attr("fill", "brown")
            .attr("stroke", "none")
            .attr("stroke-width", "0");
        }
      });
      let selectedDesk = null;
      filteredDesks?.forEach((d) => {
        const deskID = d.id.split("-")[0];

        const desk = d3.select(`#desk-${deskID}`);

        desk

          .attr("data-tooltip-content", d.alias)
          .attr("data-tooltip-timestamp", d.timestamp);

        if (
          isBasicUser &&
          (d.status === "Blocked" ||
            d.status === "Under Maintenance" ||
            d.status === "No status")
        ) {
          desk.attr("data-tooltip-state", "Blocked");
        } else {
          desk.attr("data-tooltip-state", d.status);
        }

        if (!isBasicUser) {
          if (d.status === "Unoccupied") {
            if (d.timestamp) {
              const timestamp = moment(d.timestamp);
              const currentDate = moment();
              const duration = moment
                .duration(currentDate.diff(timestamp))
                .asMinutes();
              // console.log("duration", { duration, status: d });
              if (duration >= 45) {
                desk.attr("fill", "green");
              } else {
                desk.attr("fill", "orange");
              }
            } else {
              desk.attr("fill", "green");
            }

            return;
          } else if (d.status === "Occupied") {
            desk.attr("fill", "red");
            return;
          } else if (d.status === "Blocked") {
            desk.attr("fill", "blue");
            return;
          } else if (d.status === "Under Maintenance") {
            desk.attr("fill", "black");
            return;
          } else {
            desk.attr("fill", "pink");

            // doesn't have a sensor

            return;
          }
        } else {
          if (d.status === "Unoccupied") {
            if (d.timestamp) {
              const timestamp = moment(d.timestamp);
              const currentDate = moment();
              const duration = moment
                .duration(currentDate.diff(timestamp))
                .asHours();

              if (duration >= 1) {
                desk.attr("fill", "green");
              } else {
                desk.attr("fill", "orange");
              }
            } else {
              desk.attr("fill", "green");
            }

            return;
          } else if (d.status === "Occupied") {
            desk.attr("fill", "red");
            return;
          } else {
            desk.attr("fill", "blue");
            return;
          }
        }
      });

      setAvailableDesks(
        `${floor?.capacity - (floor?.occupied + floor?.unavailable)}`,
      );
    }

    handleColors();
  }, [desks, floor, id]);

  return (
    <div
      ref={svgContainer}
      className="svgWrapper tvSvgWrapper w-full h-full"
      dangerouslySetInnerHTML={{
        __html: svg,
      }}
    />
  );
};
